import { dynamic } from '#/utils/dynamic';

export const staffModalComponentByType = {
  DELETE_CONTENT: dynamic(
    () =>
      import('./DeleteContent/StaffDeleteContentModal').then((module) => ({
        default: module.StaffDeleteContentModal,
      })),
    { strategy: 'always' },
  ),
  STAFF_APPROVE_ITEM: dynamic(
    () =>
      import('./ApproveItem/StaffApproveItemModal').then((module) => ({
        default: module.StaffApproveItemModal,
      })),
    { strategy: 'always' },
  ),
  CONFIRM_MERGE_ORG: dynamic(
    () =>
      import('#/modules/staff/orgDashboard/modals/ConfirmMergeOrg/StaffOrgDashboardConfirmMergeOrgModal').then(
        (module) => ({ default: module.StaffOrgDashboardConfirmMergeOrgModal }),
      ),
    { strategy: 'always' },
  ),
  DELETE_CATEGORY: dynamic(
    () =>
      import('./DeleteCategory/StaffDeleteCategoryModal').then((module) => ({
        default: module.StaffDeleteCategoryModal,
      })),
    { strategy: 'always' },
  ),
  REFUND_PAYMENT_MODAL: dynamic(
    () =>
      import('./RefundPayment/StaffRefundPaymentModal').then((module) => ({
        default: module.StaffRefundPaymentModal,
      })),
    { strategy: 'always' },
  ),
  VOID_LINE_ITEM: dynamic(
    () =>
      import('./VoidLineItem/StaffVoidLineItemModal').then((module) => ({
        default: module.StaffVoidLineItemModal,
      })),
    { strategy: 'always' },
  ),
  CANCEL_CREDITS: dynamic(
    () =>
      import('./CancelCredits/StaffCancelCreditsModal').then((module) => ({
        default: module.StaffCancelCreditsModal,
      })),
    { strategy: 'always' },
  ),
  STAFF_DELETE_EMAIL_PROMO: dynamic(
    () =>
      import('./DeleteEmailPromo/StaffDeleteEmailPromoModal').then(
        (module) => ({
          default: module.StaffDeleteEmailPromoModal,
        }),
      ),
    { strategy: 'always' },
  ),
  STAFF_DELETE_NOTIFICATION_CONFIGURATION: dynamic(
    () =>
      import('./DeleteNotificationConfiguration/StaffDeleteNotificationConfigurationModal').then(
        (module) => ({
          default: module.StaffDeleteNotificationConfigurationModal,
        }),
      ),
    { strategy: 'always' },
  ),
  DELETE_JOB_FAMILY: dynamic(
    () =>
      import('#/modules/staff/cms/compDb/modals/DeleteJobFamily/StaffDeleteJobFamilyModal').then(
        (module) => ({ default: module.StaffDeleteJobFamilyModal }),
      ),
    { strategy: 'always' },
  ),
  DELETE_JOB_TITLE: dynamic(
    () =>
      import('./DeleteJobTitle/StaffDeleteJobTitleModal').then((module) => ({
        default: module.StaffDeleteJobTitleModal,
      })),
    { strategy: 'always' },
  ),
  DELETE_LOCATION_GROUP: dynamic(
    () =>
      import('./DeleteLocationGroup/StaffDeleteLocationGroupModal').then(
        (module) => ({
          default: module.StaffDeleteLocationGroupModal,
        }),
      ),
    { strategy: 'always' },
  ),
  DELETE_LOCATION: dynamic(
    () =>
      import('./DeleteLandingPageLocation/StaffDeleteLandingPageLocationModal').then(
        (module) => ({
          default: module.StaffDeleteLandingPageLocationModal,
        }),
      ),
    { strategy: 'always' },
  ),
} as const satisfies Record<string, unknown>;
